import React, { useState } from "react";
import { Nav, NavItem, NavLink, Spinner } from "reactstrap";
import { useTable, useSortBy, useBlockLayout } from "react-table";
import { useMemo } from "react";
import classNames from "classnames";
import { FaFacebook, FaInstagram } from "react-icons/fa6";

const TableSelector = ({ useQuery, params }) => {
  const { data, isFetching } = useQuery(...params);
  const [tab, setTab] = useState(0);

  const tableData = data[tab];

  const columns = useMemo(() => tableData.headers, [data, tab]);
  const dataRows = useMemo(() => tableData.rows, [data, tab]);

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable(
      {
        columns,
        data: dataRows,
      },
      useSortBy,
      useBlockLayout
    );

  return (
    <>
      {isFetching && <Spinner color="primary" />}
      <Nav pills className="navtab-bg center-pills mb-2">
        {data?.map((source, index) => (
          <NavItem key={source.label}>
            <NavLink
              href="#"
              className={classNames({ active: tab === index })}
              onClick={() => setTab(index)}
            >
              {source.label}
            </NavLink>
          </NavItem>
        ))}
      </Nav>
      <table
        key={tab}
        className="table table-hover table-centered table-nowrap mb-0 text-white table-responsive"
        style={{
          width: "100%",
          tableLayout: "fixed",
          borderCollapse: "collapse",
        }}
        {...getTableProps()}
      >
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr
              {...headerGroup.getHeaderGroupProps()}
              style={{
                ...headerGroup.getHeaderGroupProps().style,
                borderBottom: "unset",
              }}
            >
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  style={{
                    ...column.getHeaderProps().style,
                    position: "relative",
                  }}
                >
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      column.isSortedDesc ? (
                        <span className="mdi mdi-chevron-down"></span>
                      ) : (
                        <span className="mdi mdi-chevron-up"></span>
                      )
                    ) : (
                      ""
                    )}
                  </span>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => {
                  if (cell?.column?.type === "link" && cell.row.original.link) {
                    return (
                      <td
                        style={{
                          ...cell.getCellProps().style,
                          width: cell.column.width,
                        }}
                        {...cell.getCellProps()}
                      >
                        {cell?.row.original?.provider === "facebook" && (
                          <FaFacebook />
                        )}
                        {cell?.row.original?.provider === "instagram" && (
                          <FaInstagram />
                        )}
                        <a
                          href={cell.row.original.link}
                          rel="noopener noreferrer"
                          target="_blank"
                          style={{
                            color: "unset",
                            textDecoration: "underline",
                            marginLeft: "5px",
                          }}
                        >
                          {cell.render("Cell")}
                        </a>
                      </td>
                    );
                  }
                  return (
                    <td
                      style={{
                        ...cell.getCellProps().style,
                        width: cell.column.width,
                      }}
                      {...cell.getCellProps()}
                    >
                      {cell.render("Cell")}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </>
  );
};

export default TableSelector;
